// Attachment helpers - validate files (no base64 conversion on client)
// Keep files in memory and only upload on Send
const MAX_ATTACHMENT_SIZE = 10 * 1024 * 1024; // 10MB per file (tunable)
const ALLOWED_TYPES = [
    'application/pdf',
    'image/png',
    'image/jpeg',
    'image/jpg',
    'image/gif',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'text/plain',
];

export function validateFile(file) {
    if (!file) return { valid: false, reason: 'No file' };
    if (file.size > MAX_ATTACHMENT_SIZE) return { valid: false, reason: 'File too large' };
    if (ALLOWED_TYPES.indexOf(file.type) === -1) return { valid: false, reason: 'Invalid file type' };
    return { valid: true };
}

// Accepts FileList or array of File and returns validated File objects
export function filesToValidatedFiles(fileList) {
    const files = Array.from(fileList || []);
    const results = [];
    for (const f of files) {
        const validation = validateFile(f);
        if (!validation.valid) throw new Error(`${f.name}: ${validation.reason}`);
        results.push(f);
    }
    return results;
}

export { MAX_ATTACHMENT_SIZE };
